
import { initSignIn } from '../../Login/actions/init-signIn'

import firebase from '../../../firebase'

export const loginWithAccessToken = (accessToken) => (dispatch, getState) => {

  return Promise.resolve(dispatch({
    type: "loginWithAccessToken",
    accessToken
  }))

    .then((action) => {

      return signInWithCustomToken(accessToken, dispatch)

    })

}

const signInWithCustomToken = (accessToken, next) => {

  return firebase.auth().signInWithCustomToken(accessToken)

    .then((authResponse) => {

      var {user: {uid, email}} = authResponse;

      return {
        user: {
          uid,
          email
        }
      }

    })

    .then(authResponse => {

      return next({
        type: "userSignInResponse",
        user: authResponse.user
      })

    })

    .catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
    // ...
    })

    .then((authUser) => {

      if (authUser) return initSignIn(authUser, next).then(() => authUser)
      return {}
    })

}



// WEBPACK FOOTER //
// ./src/Components/App/actions/index.js